(function () {
	// Detect templates early; if none on this page, no-op.
	if (document.querySelector('script[type="text/template"][id^="kp-"]') === null) {
		return;
	}

	var EVENTS = ['mousemove', 'touchstart', 'keydown', 'click', 'wheel'];
	var populated = false;

	function populate() {
		if (populated) {
			return;
		}
		populated = true;

		// Remove all listeners — once any has fired, we no longer need them.
		for (var i = 0; i < EVENTS.length; i++) {
			document.removeEventListener(EVENTS[i], populate);
		}

		// Re-query at populate time in case the tab plugin moved the scripts after load.
		var templates = document.querySelectorAll('script[type="text/template"][id^="kp-"]');
		for (var j = 0; j < templates.length; j++) {
			var tpl = templates[j];
			var parent = tpl.parentNode;
			if (parent === null) {
				continue;
			}
			var wrapper = document.createElement('div');
			wrapper.innerHTML = tpl.textContent;
			while (wrapper.firstChild !== null) {
				parent.insertBefore(wrapper.firstChild, tpl);
			}
			parent.removeChild(tpl);
		}
	}

	// First human interaction populates all tabs at once.
	// mousemove (desktop), touchstart (mobile), keydown (kb/a11y), click (everyone), wheel (desktop scroll).
	// Deliberately NOT scroll - Googlebot WRS scrolls programmatically (fires scroll, not wheel).
	for (var k = 0; k < EVENTS.length; k++) {
		document.addEventListener(EVENTS[k], populate, { once: true, passive: true });
	}
})();
